import { render, staticRenderFns } from "./ActivityRecord.vue?vue&type=template&id=ff614594&scoped=true"
import script from "./ActivityRecord.vue?vue&type=script&lang=js"
export * from "./ActivityRecord.vue?vue&type=script&lang=js"
import style0 from "./ActivityRecord.vue?vue&type=style&index=0&id=ff614594&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff614594",
  null
  
)

export default component.exports